import { type QueryKey, skipToken, useQuery } from '@tanstack/react-query';
import isObject from 'lodash/isObject';

import { Workspaces } from '@air/api';
import { type Workspace } from '@air/api/types';
import { useIsLoggedIn } from '@air/utils-auth';

export const WORKSPACE = 'WORKSPACE';

export type WorkspaceKey = [typeof WORKSPACE, UseWorkspaceParams];

export const getWorkspaceKey = (params: UseWorkspaceParams): WorkspaceKey => {
  return [WORKSPACE, params];
};

export const isWorkspaceKey = (key: QueryKey): key is WorkspaceKey => {
  return Array.isArray(key) && key[0] === WORKSPACE && isObject(key[1]);
};

export type UseWorkspaceParams = {
  id?: Workspace['id'];
};

export const useWorkspace = ({ id }: UseWorkspaceParams) => {
  const { isLoggedIn } = useIsLoggedIn();

  return useQuery({
    queryKey: getWorkspaceKey({ id }),
    queryFn: id ? () => Workspaces.get({ workspaceId: id }) : skipToken,
    enabled: isLoggedIn && !!id,
  });
};
